(function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));


let fbShare = document.querySelector('#fblink');
let twitterShare = document.querySelector('#twitterlink');
let linkedinShare = document.querySelector('#linkedinlink');
let pageUrl =  encodeURIComponent(window.location.href);

function socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url,"NewWindow",params);
}

function setShareLinkedIn() {
    let linkedin_url = "https://www.linkedin.com/sharing/share-offsite/?url=" + pageUrl;

    socialWindow(linkedin_url);
}


function setShareTW() {
    let twitterText = document.querySelector('meta[name="twitter:description"]').content;
    let twText = encodeURIComponent(twitterText);
    let twitter_url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + twText + "&source=" + pageUrl;
    socialWindow(twitter_url);
}

try {
    window.fbAsyncInit = function() {

        FB.init({
            appId: '3003909293243876',
            xfbml: false,
            version: 'v23.0'
        });

        fbShare.addEventListener("click", function () {

            FB.ui({
                method: 'share',
                href: window.location.href,
            }, function (response) {});
        });
    }
} catch (e) {
    console.log("Error sharing to FB:", e);
};

    try {
    twitterShare.addEventListener("click", function(e) {
        e.preventDefault();
        setShareTW();
    } );
} catch (e) {
    console.log("Error sharing to X:", e);
}

    try {
    linkedinShare.addEventListener("click", function(e) {
        e.preventDefault();
        setShareLinkedIn();
    } );
} catch (e) {
    console.log("Error sharing to LinkedIn:", e);
}
